export const ACTION_TYPES = {
    CHECKOUT: "checkout",
    SUMMARY: "summary"
};
